import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=f6154d3c&"
import script from "./SecuritySetting.vue?vue&type=script&lang=js&"
export * from "./SecuritySetting.vue?vue&type=script&lang=js&"
import style0 from "./SecuritySetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports